import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import { BreadcrumbProvider } from "@/contexts/BreadcrumbContext";
import { Toaster } from "@/components/ui/sonner";

import HomePage from "@/pages/HomePage";
import CourseDetailPage from "@/pages/CourseDetailPage";
import CourseCategoryPage from "@/pages/CourseCategoryPage";
import CoursesListPage from "@/pages/CoursesListPage";
import ProductsListPage from "@/pages/ProductsListPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import MembershipsPage from "@/pages/MembershipsPage";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import ProductEditorPage from "@/pages/admin/ProductEditorPage";
import CourseEditorPage from "@/pages/admin/CourseEditorPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import MediaPage from "@/pages/MediaPage";
import AboutPage from "@/pages/AboutPage";
import AuthDialog from "@/components/AuthDialog";
import CartDrawer from "@/components/CartDrawer";

function ScrollToTopOnRoute() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);
    return null;
}

function AppShell() {
    const [authOpen, setAuthOpen] = useState(false);
    return (
        <>
            <ScrollToTopOnRoute />
            <Routes>
                <Route path="/" element={<HomePage onOpenAuth={() => setAuthOpen(true)} />} />
                <Route
                    path="/courses/:id"
                    element={<CourseDetailPage onOpenAuth={() => setAuthOpen(true)} />}
                />
                <Route
                    path="/course-categories/:slug"
                    element={<CourseCategoryPage onOpenAuth={() => setAuthOpen(true)} />}
                />
                <Route
                    path="/courses"
                    element={<CoursesListPage onOpenAuth={() => setAuthOpen(true)} />}
                />
                <Route
                    path="/products"
                    element={<ProductsListPage onOpenAuth={() => setAuthOpen(true)} />}
                />
                <Route
                    path="/products/:id"
                    element={<ProductDetailPage onOpenAuth={() => setAuthOpen(true)} />}
                />
                <Route
                    path="/account"
                    element={<AccountPage onOpenAuth={() => setAuthOpen(true)} />}
                />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/admin/products/new" element={<ProductEditorPage onOpenAuth={() => setAuthOpen(true)} />} />
                <Route path="/admin/products/:id/edit" element={<ProductEditorPage onOpenAuth={() => setAuthOpen(true)} />} />
                <Route path="/admin/courses/new" element={<CourseEditorPage onOpenAuth={() => setAuthOpen(true)} />} />
                <Route path="/admin/courses/:id/edit" element={<CourseEditorPage onOpenAuth={() => setAuthOpen(true)} />} />
                <Route path="/membership" element={<MembershipsPage onOpenAuth={() => setAuthOpen(true)} />} />
                <Route path="/media" element={<MediaPage onOpenAuth={() => setAuthOpen(true)} />} />
                <Route path="/about" element={<AboutPage onOpenAuth={() => setAuthOpen(true)} />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
            </Routes>
            <AuthDialog open={authOpen} onOpenChange={setAuthOpen} />
            <CartDrawer onRequireAuth={() => setAuthOpen(true)} />
        </>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <CartProvider>
                <BreadcrumbProvider>
                    <BrowserRouter>
                        <AppShell />
                    </BrowserRouter>
                    <Toaster position="bottom-right" richColors closeButton />
                </BreadcrumbProvider>
            </CartProvider>
        </AuthProvider>
    );
}
